import React, { Dispatch, SetStateAction } from 'react'
import { TableBody, TableCell, TableRow, Table, TableHead } from '@mui/material'
import { Status, StatusType, Modal, Icon } from 'components'

import * as S from './styles'
import { Ordemvenda, StatusOV } from 'container/Home/components/Banners/interface'
import { CustomBoolean } from 'constants/enums'

export interface ClientsListInterface {
  cd_clie: string
  nm_pcro: string
  nr_cnpj_cpf: string
  key: string
  fl_sele: CustomBoolean
}
interface ModalVerOvsProps {
  isOpen: boolean
  orderNumber: string
  ordensVenda: Ordemvenda[]
  setIsOpen: Dispatch<SetStateAction<boolean>>
}

const ModalVerOvs: React.FC<ModalVerOvsProps> = ({
  isOpen: isOpen,
  orderNumber,
  setIsOpen,
  ordensVenda
}) => {
  function myStatus(item: Ordemvenda['ds_stat_orde_vend']): StatusType {
    if (item) {
      const result = StatusOV[item]?.split('-')
      return result[0].trim().toLocaleUpperCase() as StatusType
    }
    return '' as StatusType
  }

  const renderHavComplexTable = () => (
    <S.WrapDesktopTableStyled>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Status</TableCell>
            <TableCell>Nº da OV Portal</TableCell>
            <TableCell>Nº da OV SAP</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {ordensVenda.map((item: Ordemvenda) => (
            <TableRow key={item.nr_orde_vend} style={{ textAlign: 'left' }}>
              <TableCell align="left" className="nr_orde_vend">
                <Status
                  status={myStatus(item.ds_stat_orde_vend)}
                  label={StatusOV[item.ds_stat_orde_vend]}
                />
              </TableCell>
              <TableCell align="left" className="nr_orde_vend">
                {item.nr_orde_vend}
                {'  '}
                <S.ActionButton
                  onClick={() => navigator.clipboard.writeText(item.nr_orde_vend)}
                  disabled={false}
                >
                  <Icon icon="duplicate" size="15" />
                </S.ActionButton>
              </TableCell>
              <TableCell align="left" className="nr_orde_vend">
                {!!item?.nr_doct_orde_vend && (
                  <>
                    {item.nr_doct_orde_vend}
                    {'  '}
                    <S.ActionButton
                      onClick={() =>
                        navigator.clipboard.writeText(
                          item?.nr_doct_orde_vend ? item.nr_doct_orde_vend : ''
                        )
                      }
                      disabled={false}
                    >
                      <Icon icon="duplicate" size="15" />
                    </S.ActionButton>
                  </>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </S.WrapDesktopTableStyled>
  )

  return (
    <Modal open={isOpen} title="OVs do pedido" setOpen={setIsOpen}>
      <S.ModalContent>
        <S.ModalInfo>
          Você está visualizando uma lista das Ordens de Venda do{' '}
          <strong>Pedido #{orderNumber}</strong>
        </S.ModalInfo>
        <S.WrapTableStyled>{renderHavComplexTable()}</S.WrapTableStyled>
      </S.ModalContent>
    </Modal>
  )
}

export default ModalVerOvs
